export const SUBMIT = 'CHANGE_EMAIL/SUBMIT'
